import { COOKIES, setCookie } from './helpers';

export const localeRegex = /^[a-z]{2}_[A-Z]{2}$/;

type LabelsObject = Record<string, Record<string, string>>;

export const t = (locale: string, labels: LabelsObject, parent: string, anchor: string, defaultValue?: string) => {
  parent = parent.trim().toLowerCase().replace(/[_\s]/g, '.');
  anchor = anchor.trim().toLowerCase().replace(/[_\s]/g, '.');
  defaultValue = defaultValue === undefined ? null : defaultValue;

  let returnValue = `${parent}.${anchor}`;

  if (Array.isArray(labels)) {
    if (labels.length > 0) {
      const foundKey = labels.filter((item) => item.parentId === parent && item.anchorId === anchor);
      if (foundKey.length > 0) {
        returnValue = foundKey[0].value;
      }
    }
  }

  if (!['default', 'int'].includes(locale) && returnValue === `${parent}.${anchor}`) {
    console.error('Using OLD i18n');
  }

  if (parent === 'bolsa' && anchor.includes('only.standard.delivery') && returnValue === `${parent}.${anchor}`) {
    returnValue = '';
  }

  return returnValue || '';
};

export const newT = (labels: Record<string, Record<string, string>>, parent: string, anchor: string) => {
  const defaultReturn = `${parent}.${anchor}`;
  let foundKey = null;

  try {
    if (labels !== undefined) {
      parent = parent.trim().toLowerCase().replace(/[_\s]/g, '.');
      anchor = anchor.trim().toLowerCase().replace(/[_\s]/g, '.');

      const parentObject = labels[parent];

      if (parentObject) {
        const anchorText = parentObject[anchor];

        if (anchorText !== undefined) {
          foundKey = anchorText;
        }
      }

      const returnObject = { foundKey, defaultReturn };

      return returnObject;
    }

    return { foundKey, defaultReturn };
  } catch (e) {
    // console.log('[I18N] ERROR', labels, parent, anchor);
    return { foundKey, defaultReturn };
  }
};

export function setGBCookie(value: string) {
  setCookie(COOKIES.GB_COUNTRY, value, 29);
}
